module.exports = __webpack_public_path__ + "841768dd68acb77ca36fc8e678274416.pdf";